export default __webpack_public_path__ + "static/media/pink-cloud.dc256173.jpeg";